export default __webpack_public_path__ + "static/media/Shop.6a021362.png";